
export const formatDate = (date: Date | string | null): string => {
  if (!date) return "-";
  const d = typeof date === "string" ? new Date(date) : date;
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
};

export const getCostPercent = (cost: string, total: number): number => {
  if (total === 0) return 0;
  return (parseFloat(cost) / total) * 100;
};
